var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-tags flex-wrap"},_vm._l((_vm.tags),function(item,i){return _c('div',{key:i,staticClass:"item"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }